import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./lib/pdf-bootstrap";  // Initialize PDF.js worker
import HOAApp from "./HOAApp";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HOAApp />
  </React.StrictMode>,
);
